var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    {
      ref: "boardContainer",
      staticClass: "board_main_container",
      style: {
        height: "100%",
      },
    },
    [
      _c("board-view", {
        attrs: {
          tasksMap: _vm.tasksMap,
          projectResources: _vm.projectResources,
          columns: _vm.columns,
          colWidth: _vm.colWidth,
          showFilterStub: _vm.showFilterStub,
          columnDragging: _vm.columnDragging,
          taskDragging: _vm.taskDragging,
          collapsed: _vm.collapsed,
          dragPutRestricted: _vm.dragPutRestricted,
          canDragTasks: _vm.canDragTasks,
          isBoardConfigLoading: _vm.isBoardConfigLoading,
          boardHeight: _vm.boardHeight,
          draftTasks: _vm.draftTasks,
        },
        on: {
          onColumnDragStart: _vm.onColumnDragStart,
          onColumnDrop: _vm.onColumnDrop,
          taskDragStart: _vm.taskDragStart,
          onTaskDrop: _vm.onTaskDrop,
          onCollapse: _vm.onCollapse,
          taskChange: _vm.taskChange,
          createTask: _vm.createTask,
          editField: _vm.editField,
        },
      }),
      _vm._v(" "),
      _c("confirm-popup", {
        attrs: {
          show: _vm.confirmDeletionData.showPopup,
          text: _vm.confirmDeletionData.text,
          "ok-button": { type: "destructive", title: _vm.locale("common_yes") },
          "cancel-button": {
            type: "secondary",
            title: _vm.locale("common_cancel"),
          },
          "popup-width": 440,
        },
        on: {
          onClickOk: _vm.handleConfirmDeleteTask,
          onClickCancel: _vm.handleCancelDeleteTask,
        },
      }),
      _vm._v(" "),
      _c("context-menus", {
        on: {
          editField: _vm.editField,
          moveColumn: _vm.moveColumn,
          showTaskSettings: _vm.showTaskSettings,
          taskChange: _vm.taskChange,
          deleteTask: _vm.showDeleteConfirmationPopup,
        },
      }),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }